import * as React from 'react'
import Svg from '../Svg'
export const SvgWind = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        viewBox="0 0 100 100"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M0 56.2C0 52.8 2.8 50 6.2 50H75c4.7 0 8.9-2.7 11.1-6.7s1.9-9.2-.9-13c-2.7-3.7-7.3-5.8-11.9-5.2-4.7.6-8.4 3.7-10 8.1-.8 2.5-3.1 4.2-5.6 4.2-2.2 0-4.1-1.1-5.3-2.8-1.2-1.7-1.4-3.9-.8-5.9 2.2-5.8 6.2-10.5 11.7-13.3 5.5-3 11.7-3.7 17.6-2.2 5.9 1.4 11.1 5 14.7 10 3.4 5 5 11.1 4.2 17.2-.8 6.1-3.6 11.7-8.3 15.8-4.5 4.1-10.4 6.3-16.5 6.3h-.3c3.6 6.1 4.4 13.6 2.2 20.3-2.2 6.7-7.2 12.3-13.7 15.1-6.6 2.8-13.9 2.8-20.5-.2s-11.4-8.6-13.6-15.3c-.5-1.7-.2-3.7.9-5.2 1.1-1.6 2.8-2.3 4.7-2.3 2.8 0 5.3 1.6 6.4 4.2 2 6.1 8.3 9.7 14.5 8.3s10.5-7.3 9.7-13.7c-.8-6.6-6.4-11.4-13.1-11.2h-46c-3.4 0-6.2-2.8-6.2-6.3zm23.4-28.1H6.2c-3.4 0-6.2 2.8-6.2 6.2 0 1.7.6 3.3 1.9 4.4s2.7 1.9 4.4 1.9h17.2c5.5 0 10.6-2.2 14.5-6.1 3.7-3.9 5.9-9.1 5.8-14.5S41.2 9.2 37.2 5.5 27.8-.3 22.2 0C15.9.5 10 3.8 6.6 9.1c-1.2 2-1.4 4.4-.3 6.4s3.3 3.3 5.5 3.3 4.1-1.1 5.3-3c1.9-2.8 5.5-4.1 8.6-3 2.5.8 4.5 2.8 5.3 5.3.6 2.3.2 4.8-1.2 6.9s-3.9 3.1-6.4 3.1z" />
    </Svg>
)
SvgWind.isIcon = true
export default SvgWind
